<template>
    <div class="menu">
        <el-menu :default-active="defaultActive" :collapse="userStore.isCollapse" router unique-opened>
            <side-menu
                v-for="item in userStore.menuRoutes"
                :key="item.path"
                :menu="item"
                :base-path="item.path"
            ></side-menu>
        </el-menu>
    </div>
</template>

<script>
import SideMenu from "./SideMenu.vue";
import useUserStore from '@/store/user';

export default {
    components: {
        SideMenu,
    },
    data() {
        return {
            // defaultActive: '/index',
        }
    },
    computed: {
        userStore() {
            return useUserStore();
        },
        defaultActive() {
            const activeMenu = this.$route.meta.activeMenu;
            return activeMenu ? activeMenu : this.$route.fullPath.split('?')[0];
        },
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.menu {
    width: max-content;
    height: 100%;
    overflow: auto;
}
.el-menu:not(.el-menu--collapse) {
    width: 200px;
}
.el-menu {
    min-height: calc(100vh - 60px);
}
.el-menu--collapse .el-sub-menu {
    display: flex;
}
</style>
